import React, { useCallback, useEffect, useRef } from "react";
import gsap from "gsap";
import { StyledPreventPageScroll } from "../../../helpers/PreventPageScroll";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useClickOutside from "../../../hooks/useClickOutside";
import useEscClick from "../../../hooks/useEscClick";
import useModalFocus from "../../../hooks/useModalFocus";
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12 10.586 4.95-4.95 1.415 1.415-4.95 4.95 4.95 4.95-1.415 1.414-4.95-4.95-4.95 4.95-1.413-1.415 4.95-4.95-4.95-4.95L7.05 5.638l4.95 4.95Z",
    fill: "#fff",
    fillOpacity: ".8"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
};
import { animationDuration } from "../../../settings";
import IconAtm from "../../atoms/IconAtm";
import PushOrg from "../PushOrg";
import { modalLargeMaxWidthUnit, modalMarginUnit } from "./SideDarkModalOrg.settings";
import { CloseButtonWrapper, Container, Header, ModalWrapper, Overlay } from "./SideDarkModalOrg.styled";
var SideDarkModalOrg = function SideDarkModalOrg(_ref) {
  var header = _ref.header,
    content = _ref.content,
    isOpen = _ref.isOpen,
    onCloseButtonClick = _ref.onCloseButtonClick;
  var ref = useRef(null);
  var isMediumUp = useBreakpoint("medium");
  var _useModalFocus = useModalFocus(ref),
    handleKeyDown = _useModalFocus.handleKeyDown,
    handleFocusOnModalClose = _useModalFocus.handleFocusOnModalClose;
  var modalPositionHorizontal = modalLargeMaxWidthUnit + 2 * modalMarginUnit;
  useEffect(function () {
    if (!isOpen) {
      return;
    }
    if (isMediumUp) {
      gsap.fromTo(ref.current, {
        x: modalPositionHorizontal,
        opacity: 1,
        ease: "slow"
      }, {
        x: 0,
        ease: "slow"
      });
    } else {
      gsap.fromTo(ref.current, {
        x: 0,
        yPercent: 100,
        opacity: 1,
        ease: "slow"
      }, {
        x: 0,
        yPercent: 0,
        ease: "slow"
      });
    }
  }, [ref, isOpen, modalPositionHorizontal, isMediumUp]);
  var handleCloseButtonClick = useCallback(function (event) {
    if (isMediumUp) {
      gsap.fromTo(ref.current, {
        x: 0
      }, {
        x: modalPositionHorizontal
      });
    } else {
      gsap.fromTo(ref.current, {
        yPercent: 0,
        ease: "slow"
      }, {
        yPercent: 100,
        ease: "slow"
      });
    }
    setTimeout(function () {
      return onCloseButtonClick(event);
    }, animationDuration.slow);
    handleFocusOnModalClose();
  }, [ref, onCloseButtonClick, modalPositionHorizontal, isMediumUp]);
  useClickOutside(ref, handleCloseButtonClick);
  useEscClick(ref, handleCloseButtonClick);
  return isOpen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPreventPageScroll, null), /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(ModalWrapper, {
    ref: ref,
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/React.createElement(CloseButtonWrapper, {
    onClick: handleCloseButtonClick
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: CloseIcon,
    sizeSpace: 3,
    color: "white",
    emphasis: "medium"
  })), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, null, header), /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: {
      small: 4,
      medium: 5,
      large: 5
    },
    bottomSpace: 8,
    hasNoReset: true
  }, content))))) : null;
};
export default SideDarkModalOrg;